<template>
  <div>
    <CHeader fixed with-subheader light c-header-fixed :color-scheme="this.$store.state.theme_mode">
          <CToggler
              in-header
              class="ml-3 d-lg-none"
              @click="$store.commit('toggleSidebarMobile')"
          />
<!--          <CToggler-->
<!--              in-header-->
<!--              class="ml-3 d-md-down-none"-->
<!--              @click="$store.commit('toggleSidebarDesktop')"-->
<!--          />-->
      <CHeaderBrand class="mx-auto d-lg-none" to="/">
        <!--      <CIcon name="logo" height="48" alt="Logo"/>-->
      </CHeaderBrand>

      <CHeaderNav class="d-md-down-none">
<!--        <CHeaderNavItem class=" border-left">-->
<!--          <CHeaderNavLink to="/dashboard/orders/add-order">-->
<!--            {{ $t('sidebars.addOrder') }}-->
<!--          </CHeaderNavLink>-->

<!--        </CHeaderNavItem>-->
<!--        <CDropdown-->

<!--            class="c-header-nav-items mr-3 border-left"-->
<!--            :placement="drop_down_placement"-->
<!--            add-menu-classes=""-->
<!--        >-->
<!--          <template #toggler>-->
<!--            <CHeaderNavLink>-->
<!--              {{ $t('sidebars.addSellDocument') }}-->
<!--            </CHeaderNavLink>-->
<!--          </template>-->


<!--          <CDropdownItem >-->
<!--            {{$t('sidebars.cash')}}-->
<!--          </CDropdownItem>-->

<!--          <CDropdownItem >-->
<!--            {{$t('sidebars.credit')}}-->
<!--          </CDropdownItem>-->
<!--        </CDropdown>-->
<!--        <CHeaderNavItem class=" border-left">-->
<!--          <CHeaderNavLink @click.native="open_sell_factor" target="_blank">-->
<!--            {{ $t('sidebars.addSellDocument') }}-->
<!--          </CHeaderNavLink>-->

<!--        </CHeaderNavItem>-->
        <!--//******************************************-->
<!--        <CHeaderNavItem class=" border-left">-->
<!--          <CHeaderNavLink to="/dashboard/accounting/receive-operation" target="_blank" exact>-->
<!--            {{ $t('sidebars.receiveOperation') }}-->
<!--          </CHeaderNavLink>-->
<!--        </CHeaderNavItem>-->
        <!--//******************************************-->      <!--//******************************************-->
<!--        <CHeaderNavItem class=" border-left">-->
<!--          <CHeaderNavLink to="/dashboard/accounting/pay-operation" target="_blank" exact>-->
<!--            {{ $t('sidebars.payOperation') }}-->
<!--          </CHeaderNavLink>-->
<!--        </CHeaderNavItem>-->
        <!--//******************************************-->
<!--        <CHeaderNavItem v-if="get_access('journal')" class=" border-left">-->
<!--          <CHeaderNavLink to="/dashboard/accounting/add-accounting-doc" target="_blank" exact>-->
<!--            {{ $t('sidebars.journal') }}-->
<!--          </CHeaderNavLink>-->
<!--        </CHeaderNavItem>-->
        <!--//******************************************-->

<!--          <CDropdown-->
<!--v-if="get_access('header_view')"-->
<!--              class="c-header-nav-items  border-left"-->
<!--              :placement="drop_down_placement"-->
<!--              add-menu-classes=""-->
<!--          >-->
<!--            <template #toggler>-->
<!--              <CHeaderNavLink class="p-1">-->
<!--                {{ $t('sidebars.view') }}-->
<!--              </CHeaderNavLink>-->
<!--            </template>-->


<!--            <CDropdownItem class="p-1"  @click="open_orders()">-->
<!--              {{$t('sidebars.quotes')}}-->
<!--            </CDropdownItem>-->

<!--            <CDropdownItem class="p-1">-->
<!--              {{$t('sidebars.invoices')}}-->
<!--            </CDropdownItem>-->
<!--            <CDropdownItem v-if="get_access('delivery')" class="p-1" to="/dashboard/delivery/order-list">-->
<!--              {{$t('sidebars.delivery')}}-->
<!--            </CDropdownItem>-->
<!--            <CDropdownItem class="p-1" to="/dashboard/orders/add-order">-->
<!--              {{$t('sidebars.purchase')}}-->
<!--            </CDropdownItem>-->
<!--            <CDropdownItem class="p-1" to="/dashboard/products/list">-->
<!--              {{$t('sidebars.item')}}-->
<!--            </CDropdownItem>-->
<!--            <CDropdownItem class="p-1" to="/dashboard/sale-orders/list-customer">-->
<!--              {{$t('sidebars.customers')}}-->
<!--            </CDropdownItem>-->
<!--            <CDropdownItem class="p-1" to="/dashboard/orders/report">-->
<!--              {{$t('sidebars.suppliers')}}-->
<!--            </CDropdownItem>-->
<!--            <CDropdownItem class="p-1">-->
<!--              {{$t('payingList')}}-->
<!--            </CDropdownItem>-->
<!--          </CDropdown>-->
        <!--//******************************************-->
        <!--//******************************************-->
<!--        <CHeaderNavItem class=" border-left">-->

<!--          <CHeaderNavLink to="/dashboard/orders/purchase-doc/1" target="_blank">-->
<!--            {{ $t('sidebars.addBuyDocument') }}-->
<!--          </CHeaderNavLink>-->
<!--        </CHeaderNavItem>-->
        <!--//******************************************-->
<!--        <CHeaderNavItem class=" border-left">-->

<!--          <CHeaderNavLink to="/dashboard/products/inventory-return-operation" target="_blank">-->
<!--            {{ $t('returnOperation') }}-->
<!--          </CHeaderNavLink>-->
<!--        </CHeaderNavItem>-->
        <!--//******************************************-->


<!--        <CHeaderNavItem v-if="get_access('delivery')" class=" border-left">-->
<!--          <CHeaderNavLink to="/dashboard/visitors/drivers" target="_blank" exact>-->
<!--            {{ $t('sidebars.delivery') }}-->
<!--          </CHeaderNavLink>-->
<!--        </CHeaderNavItem>-->
        <!--//******************************************-->

<!--        <CHeaderNavItem v-if="get_access('cartable')" class=" border-left">-->
<!--          <CHeaderNavLink to="/dashboard/orders/cartable"  exact>-->
<!--            {{ $t('cartboard') }}-->
<!--&lt;!&ndash;            <CBadge  class="mr-2" color="success">{{reminders.length}}</CBadge>&ndash;&gt;-->

<!--          </CHeaderNavLink>-->

<!--        </CHeaderNavItem>-->
        <!--//******************************************-->
<!--        <CHeaderNavItem v-if="get_access('reminder')" class=" border-left">-->
<!--          <CHeaderNavLink to="/dashboard/base/reminder" target="_blank" exact>-->
<!--            {{ $t('sidebars.reminder') }}-->
<!--            <CBadge  class="mr-3" color="success">{{reminders.length}}</CBadge>-->

<!--          </CHeaderNavLink>-->
<!--        </CHeaderNavItem>-->
        <!--//******************************************-->
<!--        <CHeaderNavItem class=" border-left">-->
<!--          <CHeaderNavLink to="/dashboard/base/reminder" exact>-->
<!--            ریمایندر-->
<!--            <CBadge color="success" class="mr-3">{{reminders.length}}</CBadge>-->

<!--          </CHeaderNavLink>-->
<!--        </CHeaderNavItem>-->
        <!--//******************************************-->
<!--        <CDropdown-->
<!--            inNav-->
<!--            class="c-header-nav-items"-->
<!--            placement="bottom-end"-->
<!--            add-menu-classes="pt-0"-->
<!--        >-->
<!--          <template #toggler>-->
<!--            <CHeaderNavLink>-->
<!--              {{ $t('sidebars.reminder') }}-->
<!--              <CBadge  class="mr-3" color="success">{{reminders.length}}</CBadge>-->

<!--            </CHeaderNavLink>-->
<!--          </template>-->

<!--          <CDropdownItem to="/dashboard/base/reminder">-->
<!--            {{ $t('sidebars.reminderList') }}-->
<!--          </CDropdownItem>-->
<!--          <CDropdownItem v-for="reminder in reminders" v-bind:key="reminder.id">-->
<!--            &lt;!&ndash;            <CIcon name="cil-check"/>&ndash;&gt;-->
<!--            {{reminder.note}} {{reminder.startTime}}-->
<!--          </CDropdownItem>-->

<!--        </CDropdown>-->

        <!--//******************************************-->


        <!--//******************************************-->

      </CHeaderNav>

      <CHeaderNav class="mr-4  mr-auto">
        <!--        ******************************************8-->
        <CHeaderNavItem class="d-md-down-none mx-2" v-if="multiple_language == 'true'">

          <CSelect
              :value.sync="selected_language"
              :options="[{label:'English',value:'en'},{label:'فارسی',value:'fa'}]"
          />

        </CHeaderNavItem>
<!--********************************************************-->
        <CHeaderNavItem class="d-md-down-none mx-2" v-if="false">
          <CHeaderNavLink>
            <CIcon name="cil-bell"/>
          </CHeaderNavLink>
        </CHeaderNavItem>

<!--*********************************************************-->
        <!--*********************************************************-->
        <CHeaderNavItem class="d-md-down-none mx-2" v-if="false">
          <CHeaderNavLink>
            <CIcon name="cil-list"/>
          </CHeaderNavLink>
        </CHeaderNavItem>
<!--*************************************************************-->
        <CHeaderNavItem class="d-md-down-none mx-2" v-if="false">
          <CButton v-on:click="darkThemeSwitch">
            <CIcon v-if="this.$store.state.theme_mode=='dark'" class="text-light" name="cil-sun"/>
            <CIcon v-if="this.$store.state.theme_mode=='light'" name="cil-moon"/>

          </CButton>
        </CHeaderNavItem>
        <!--        ******************************************8-->

        <CHeaderNavItem class="d-md-down-none mx-2" >
          <CHeaderNavLink to="/dashboard/tickets/list">
            <CIcon name="cil-envelope-open"/>
            <CBadge color="danger" size="lg" id="ticket_badge">0</CBadge>
          </CHeaderNavLink>
        </CHeaderNavItem>

<!--        ******************************************8-->
        <!--        ******************************************8-->

<!--              <TheHeaderDropdownAccnt/>-->
        <CHeaderNavItem class="d-md-down-none mx-2" v-if="false">
          <CButton @click="$store.commit('toggleAnotherSidebar')">
            <CIcon v-if="this.$store.state.theme_mode=='light'" name="cil-applications"/>
            <CIcon v-if="this.$store.state.theme_mode=='dark'" class="text-light" name="cil-applications"/>
          </CButton>
        </CHeaderNavItem>

      </CHeaderNav>
      <CSubheader class="px-1" v-if="false">
        <CCol cols="6">
          <CBreadcrumbRouter class="border-0 mb-0"/>
        </CCol>
        <CCol cols="6" ref="header_action">

        </CCol>
      </CSubheader>

    </CHeader>
    <div>
      <CCard v-if="header_validate_errors.length">
        <CCardHeader>
          <strong>{{ $t('dialogs.fixErrors') }}</strong>

        </CCardHeader>
        <CCardBody>
          <div>

            <CAlert v-for="error in header_validate_errors" show color="danger">{{ error }}</CAlert>

          </div>
        </CCardBody>
      </CCard>

    </div>
  </div>
</template>

<script>
import TheHeaderDropdownAccnt from './TheHeaderDropdownAccnt'
import themeChanger from "../theme";
import axios from "axios";
import Vue from "vue";

export default {
  name: 'TheHeader',
  components: {
    TheHeaderDropdownAccnt
  },
  data() {
    return {
      selected_language: '',
      mounted_status: 0,
      themeChanger: null,
      reminders:[],
      multiple_language: localStorage.getItem('multiple_language'),
      header_validate_errors: [],
drop_down_placement:'bottom-start',
    }
  },
  created() {
    this.themeChanger = new themeChanger();
  }, mounted() {

    this.selected_language = localStorage.getItem("language");
    console.log("selected language is ", this.selected_language)
    if(this.selected_language=='فارسی'){
      this.selected_language='fa';
    }
    if (this.selected_language == 'en') {
      this.selected_language = 'en'
      this.$i18n.locale = "en"
      localStorage.setItem("language", 'en');

    }

    if (this.selected_language == "fa") {
      this.$i18n.locale = "fa"
      this.selected_language = "fa"
      localStorage.setItem("language", "fa");
      this.drop_down_placement='bottom-end';

    }
    console.log(this.selected_language)

    // this.$root.modal_component = this.$refs.modal2;
    this.$root.root_validate_errors = [];
    this.$root.header_action = this.$refs['header_action'];
    this.$root.base_url = localStorage.getItem('api_address');
    this.$root.company_name = localStorage.getItem('app_name');
    this.header_validate_errors = this.$root.root_validate_errors;

  }, watch: {
    '$root.root_validate_errors': function () {
      // this.header_validate_errors = this.$root.root_validate_errors;
      if (this.$root.root_validate_errors.length > 0) {
        this.$root.modal_component.show_validate_errors(this.$root.root_validate_errors);
        // setTimeout(() =>
        //         this.$refs.errors_container.scrollIntoView()
        //     , 500);

      }
    },
    'selected_language': function () {
      if (this.mounted_status == 1) {
        localStorage.setItem('language', this.selected_language);
        this.$i18n.locale = this.selected_language;

        // console.log("language changed " + localStorage.getItem("language"));
        location.reload();

      } else {
        this.mounted_status = 1;

      }
    },
  }, methods: {
    open_orders(){
      localStorage.setItem("sale_factors_active_tab",1)
      window.open("/dashboard/sale-orders/sale-invoice")
      // this.$router.push({path:'/dashboard/sale-orders/sale-invoice'})
    },
    open_sell_factor(){
      localStorage.setItem("sale_factors_active_tab",0)
      window.open("/dashboard/sale-orders/sale-invoice")
      // this.$router.push({path:'/dashboard/sale-orders/sale-invoice'})
    },

    darkThemeSwitch() {
      this.$store.commit('toggle_theme_mode')
      this.themeChanger._darkThemeSwitch();
    },
  }
}
</script>
